import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';

// Components
import DropDown from '../DropDown';
import ActionListOverlay from './ActionListOverlay';
var ActionMenu = /*#__PURE__*/function (_PureComponent) {
  _inherits(ActionMenu, _PureComponent);
  var _super = _createSuper(ActionMenu);
  function ActionMenu() {
    var _this;
    _classCallCheck(this, ActionMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isVisible: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      e.stopPropagation();
    });
    _defineProperty(_assertThisInitialized(_this), "handleOverlayClick", function (e) {
      e.stopPropagation();
    });
    _defineProperty(_assertThisInitialized(_this), "handleVisibilityChange", function (isVisible) {
      _this.setState({
        isVisible: isVisible
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onActionClickHandler", function (action) {
      var onActionClick = _this.props.onActionClick;
      _this.setState({
        isVisible: false
      });
      onActionClick(action);
    });
    _defineProperty(_assertThisInitialized(_this), "renderOverlay", function () {
      var _this$props = _this.props,
        actions = _this$props.actions,
        overlayClassName = _this$props.overlayClassName,
        showTooltip = _this$props.showTooltip;
      return /*#__PURE__*/React.createElement(ActionListOverlay, {
        actions: actions,
        onActionClick: _this.onActionClickHandler,
        className: overlayClassName,
        showTooltip: showTooltip
      });
    });
    return _this;
  }
  _createClass(ActionMenu, [{
    key: "render",
    value: function render() {
      var isVisible = this.state.isVisible;
      var _this$props2 = this.props,
        children = _this$props2.children,
        placement = _this$props2.placement,
        align = _this$props2.align,
        disabled = _this$props2.disabled;
      return /*#__PURE__*/React.createElement(DropDown, {
        overlay: this.renderOverlay(),
        trigger: "click",
        visible: isVisible,
        placement: placement,
        onClick: this.handleClick,
        onOverlayClick: this.handleOverlayClick,
        onVisibleChange: this.handleVisibilityChange,
        align: align,
        disabled: disabled
      }, children);
    }
  }]);
  return ActionMenu;
}(PureComponent);
ActionMenu.propTypes = ActionListOverlay.propTypes;
ActionMenu.defaultProps = ActionListOverlay.defaultProps;
export default ActionMenu;